export default "__VITE_ASSET__DpRurvRP__"